"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateFriendly = void 0;
const formatDateFriendly = (date) => {
    // format date to dddd, MMMM D, yyyy without using moment.js
    if (!date)
        return "";
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    const dayOfWeek = d.getDay();
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    return `${dayNames[dayOfWeek]}, ${monthNames[month]} ${day}, ${year}`;
};
exports.formatDateFriendly = formatDateFriendly;
